import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PathLocationStrategy, LocationStrategy } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { CustomFormsModule } from "ng2-validation";
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { AvatarModule } from "primeng/avatar";
import { AvatarGroupModule } from "primeng/avatargroup";
import { BadgeModule } from "primeng/badge";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CarouselModule } from "primeng/carousel";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipsModule } from "primeng/chips";
import { ChipModule } from "primeng/chip";
import { CodeHighlighterModule } from "primeng/codehighlighter";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { ColorPickerModule } from "primeng/colorpicker";
import { ContextMenuModule } from "primeng/contextmenu";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { DragDropModule } from "primeng/dragdrop";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { FullCalendarModule } from "@fullcalendar/angular";
import { GalleriaModule } from "primeng/galleria";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { KnobModule } from "primeng/knob";
import { LightboxModule } from "primeng/lightbox";
import { ImageModule } from "primeng/image";
import { ListboxModule } from "primeng/listbox";
import { MegaMenuModule } from "primeng/megamenu";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { MultiSelectModule } from "primeng/multiselect";
import { OrderListModule } from "primeng/orderlist";
import { OrganizationChartModule } from "primeng/organizationchart";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from "primeng/radiobutton";
import { RatingModule } from "primeng/rating";
import { RippleModule } from "primeng/ripple";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ScrollTopModule } from "primeng/scrolltop";
import { SelectButtonModule } from "primeng/selectbutton";
import { SkeletonModule } from "primeng/skeleton";
import { SidebarModule } from "primeng/sidebar";
import { SlideMenuModule } from "primeng/slidemenu";
import { SliderModule } from "primeng/slider";
import { SplitButtonModule } from "primeng/splitbutton";
import { SplitterModule } from "primeng/splitter";
import { StepsModule } from "primeng/steps";
import { TabMenuModule } from "primeng/tabmenu";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TagModule } from "primeng/tag";
import { TerminalModule } from "primeng/terminal";
import { TieredMenuModule } from "primeng/tieredmenu";
import { TimelineModule } from "primeng/timeline";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from "primeng/treetable";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { AngMusicPlayerModule } from "ang-music-player";
import { VimeModule } from "@vime/angular";
//import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { AppCodeModule } from "./app.code.component";
import { AboutUsComponent } from "./frontend/about-us/about-us.component";
import { AppComponent } from "./app.component";
import { AppMainComponent } from "./app.main.component";
import { AppConfigComponent } from "./app.config.component";
import { AppRightpanelComponent } from "./app.rightpanel.component";
import { AppMenuComponent } from "./app.menu.component";
import { AppMenuitemComponent } from "./app.menuitem.component";
import { AppTopBarComponent } from "./app.topbar.component";
import { AppFooterComponent } from "./app.footer.component";
import { BannerComponent } from "./manage/banner/banner.component";
import { BannerAddComponent } from "./manage/banner/add/add.component";
import { BannerEditComponent } from "./manage/banner/edit/edit.component";

import { DashboardDemoComponent } from "./demo/view/dashboarddemo.component";
import { TplForPlayersComponent } from "./frontend/tplforplayers/tplforplayers.component";
import { FormLayoutDemoComponent } from "./demo/view/formlayoutdemo.component";
import { FloatLabelDemoComponent } from "./demo/view/floatlabeldemo.component";
import { InvalidStateDemoComponent } from "./demo/view/invalidstatedemo.component";
import { InputDemoComponent } from "./demo/view/inputdemo.component";
import { ButtonDemoComponent } from "./demo/view/buttondemo.component";
import { ContactUsComponent } from "./frontend/contact-us/contact-us.component";
import { TableDemoComponent } from "./demo/view/tabledemo.component";
import { ListDemoComponent } from "./demo/view/listdemo.component";
import { AppTimelineDemoComponent } from "./pages/app.timelinedemo.component";
import { TreeDemoComponent } from "./demo/view/treedemo.component";
import { PanelsDemoComponent } from "./demo/view/panelsdemo.component";
import { OverlaysDemoComponent } from "./demo/view/overlaysdemo.component";
import { MediaDemoComponent } from "./demo/view/mediademo.component";
import { MenusDemoComponent } from "./demo/view/menusdemo.component";
import { MessagesDemoComponent } from "./demo/view/messagesdemo.component";
import { MiscDemoComponent } from "./demo/view/miscdemo.component";
import { EmptyDemoComponent } from "./demo/view/emptydemo.component";
import { ChartsDemoComponent } from "./demo/view/chartsdemo.component";
import { FileDemoComponent } from "./demo/view/filedemo.component";
import { DocumentationComponent } from "./demo/view/documentation.component";
import { DisplayComponent } from "./utilities/display.component";
import { ElevationComponent } from "./utilities/elevation.component";
import { FlexboxComponent } from "./utilities/flexbox.component";
import { GridComponent } from "./utilities/grid.component";
import { IconsComponent } from "./utilities/icons.component";
import { WidgetsComponent } from "./utilities/widgets.component";
import { SpacingComponent } from "./utilities/spacing.component";
import { TypographyComponent } from "./utilities/typography.component";
import { TextComponent } from "./utilities/text.component";
import { AppCrudComponent } from "./pages/app.crud.component";
import { AppCalendarComponent } from "./pages/app.calendar.component";
import { AppInvoiceComponent } from "./pages/app.invoice.component";
import { AppHelpComponent } from "./pages/app.help.component";
import { AppNotfoundComponent } from "./pages/app.notfound.component";
import { AppErrorComponent } from "./pages/app.error.component";
import { AppAccessdeniedComponent } from "./pages/app.accessdenied.component";
import { AppLoginComponent } from "./pages/app.login.component";
import { CountryService } from "./demo/service/countryservice";
import { CustomerService } from "./demo/service/customerservice";
import { EventService } from "./demo/service/eventservice";
import { IconService } from "./demo/service/iconservice";
import { NodeService } from "./demo/service/nodeservice";
import { PhotoService } from "./demo/service/photoservice";
import { ProductService } from "./demo/service/productservice";
import { MenuService } from "./app.menu.service";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { PrivacypolicyComponent } from "./frontend/privacy-policy/privacy-policy.component";
import { TermsnconditionComponent } from "./frontend/termsncondition/termsncondition.component";
import { LoaderService } from "./services/loader.service";
import { LoaderInterceptor } from "./_helpers/loader-interceptor.service";
import { LoaderComponent } from "./pages/loader/loader.component";
import { FrontendComponent } from "./frontend/frontend.component";
import { HeaderComponent } from "./frontend/header/header.component";
import { FooterComponent } from "./frontend/footer/footer.component";
import { HomeComponent } from "./frontend/home/home.component";
import { AgentsComponent } from "./frontend/agents/agents.component";
import { AuthInterceptor } from "./_helpers/auth.interceptor";
import { ManageComponent } from "./manage/manage.component";
import { AdminLoginComponent } from "./manage/login/login.component";
import { AdminComponent } from "./manage/admin/admin.component";
import { AdminAddComponent } from "./manage/admin/add/add.component";
import { AdminEditComponent } from "./manage/admin/edit/edit.component";
import { AdminViewComponent } from "./manage/admin/view/view.component";
import { EmptyComponent } from "./manage/empty/empty.component";
import { RoleComponent } from "./manage/role/role.component";
import { RoleAddComponent } from "./manage/role/add/add.component";
import { RoleEditComponent } from "./manage/role/edit/edit.component";
import { RoleViewComponent } from "./manage/role/view/view.component";
import { CategoryComponent } from "./manage/category/category.component";
import { CategoryAddComponent } from "./manage/category/add/add.component";
import { CategoryEditComponent } from "./manage/category/edit/edit.component";
import { CategoryViewComponent } from "./manage/category/view/view.component";
import { SubcategoryComponent } from "./manage/subcategory/subcategory.component";
import { SubcategoryAddComponent } from "./manage/subcategory/add/add.component";
import { SubcategoryEditComponent } from "./manage/subcategory/edit/edit.component";
import { SubcategoryViewComponent } from "./manage/subcategory/view/view.component";
import { SignInComponent } from "./frontend/sign-in/sign-in.component";
import { UserComponent } from "./manage/user/user.component";
import { UserAddComponent } from "./manage/user/add/add.component";
import { UserEditComponent } from "./manage/user/edit/edit.component";
import { UserViewComponent } from "./manage/user/view/view.component";
import { MyAccountComponent } from "./frontend/my-account/my-account.component";
import { UserMyAccountEditComponent } from "./frontend/my-account/edit/edit.component";
import { OrdersComponent } from "./frontend/my-account/orders/orders.component";
import { ViewCustomerVenueOrderComponent } from "./frontend/my-account/orders/view/view.component";
import { CookiePolicyComponent } from "./frontend/cookie-policy/cookie-policy.component";
import { ChangeLogComponent } from "./frontend/change-log/change-log.component";
import {
  SwiperModule,
  SwiperConfigInterface,
  SWIPER_CONFIG,
} from "ngx-swiper-wrapper";
import { ClubAddComponent } from "./manage/club/add/add.component";
import { ClubEditComponent } from "./manage/club/edit/edit.component";
import { ClubComponent } from "./manage/club/club.component";
import { TplForClubsComponent } from "./frontend/tplforclubs/tplforclubs.component";
import { ClubLeaguesComponent } from "./frontend/clubleagues/clubleagues.component";
import { FaqComponent } from "./frontend/faq/faq.component";
import { PricingComponent } from "./frontend/pricing/pricing.component";
import { DataProtectionPolicyComponent } from "./frontend/data-protection-policy/data-protection-policy.component";
import { NgOtpInputModule } from "ng-otp-input";
import { ResetPasswordComponent } from "./frontend/reset-password/reset-password.component";
import { productComponent } from "./frontend/product/product.component";
import { WalletComponent } from "./frontend/wallet/wallet.component";
import { AcademyWalletComponent } from './frontend/academy/academy-wallet/academy-wallet.component';
import { FindPartnerComponent } from "./frontend/findpartner/findpartner.component";
import { whatistplComponent } from "./frontend/whatistpl/whatistpl.component";
import { QuizComponent } from "./frontend/quiz/quiz.component";
import { WallethistoryComponent } from "./manage/user/wallethistory/wallethistory.component";
import { EditorModule } from "primeng/editor";
import { ContestComponent } from "./frontend/contest/contest.component";
import { MyContestComponent } from "./frontend/contest/my-contest/my-contest.component";
import { ContestDetailsComponent } from "./frontend/contest/contest-details/contest-details.component";
import { ContestHistoryComponent } from "./frontend/contest-history/contest-history.component";
import { InformationComponent } from "./frontend/profile/info/info.component";
import { SkillsComponent } from "./frontend/profile/skill/skills.component";
import { RankingComponent } from "./frontend/profile/ranking/ranking.component";
import { MatchesComponent } from "./frontend/profile/matches/matches.component";
import { OpponentsComponent } from "./frontend/profile/opponents/opponents.component";
import { BlogComponent } from "./frontend/blog/blog.component";
import { BlogviewComponent } from "./frontend/blog/view/view.component";
import { ContestLeaderBoardComponent } from "./frontend/contest-leader-board/contest-leader-board.component";
import { MyScheduleComponent } from "./frontend/my-schedule/my-schedule.component";
import { UserscheduleListComponent } from "./manage/user/userschedule-list/userschedule-list.component";
import { FindPartnerChatHistoryComponent } from './manage/user/userschedule-list/find-partner-chat-history/find-partner-chat-history.component';
import { ProfilerequestComponent } from "./frontend/profile/profilerequest/profilerequest.component";
import { SafepipePipe } from "./frontend/change-log/safepipe.pipe";
import { AbouttheleagueComponent } from "./frontend/abouttheleague/abouttheleague.component";
import { ScoretableComponent } from "./frontend/scoretable/scoretable.component";
import { TeamsComponent } from "./frontend/teams/teams.component";
import { SponsersComponent } from "./frontend/sponsers/sponsers.component";
import { MediaComponent } from "./frontend/media/media.component";
import { HighlightsComponent } from "./frontend/highlights/highlights.component";
import { AcademiesProfileComponent } from "./frontend/academies-profile/academies-profile.component";
import { AcademiesProfileEditComponent } from "./frontend/academies-profile/academies-profile-edit/academies-profile-edit.component";
import { AcademiesProfileSliderComponent } from "./frontend/academies-profile/academies-profile-slider/academies-profile-slider.component";
import { TopPlayersComponent } from "./frontend/academies-profile/top-players/top-players.component";
import { CourtTypesComponent } from "./frontend/academies-profile/court-types/court-types.component";
import { BranchesComponent } from "./frontend/academies-profile/branches/branches.component";
import { CoachesComponent } from "./frontend/academies-profile/coaches/coaches.component";
import { AcademyHighlightsComponent } from "./frontend/academies-profile/highlights/highlights.component";
import { TeamDetailsComponent } from "./frontend/team-details/team-details.component";
import { MyTournamentComponent } from "./frontend/profile/my-tournament/my-tournament.component";
import { ProfileHeaderComponent } from "./frontend/profile/profile-header/profile-header.component";
import { ProfileEditComponent } from "./frontend/profile/info/edit/profile-edit.component";
import { ProfileEdit2Component } from "./frontend/profile/info/profile-update-edit/profile-edit.component";
import { AcademiesHeaderComponent } from "./frontend/academies-profile/academies-header/academies-header.component";
import { AcademyThankyouPageComponent } from "./frontend/academy/academythankyou/academy-thankyou-page.component";
import { AcademyFrontendPaymentListComponent } from "./frontend/academypayment/list.component";
import { OurTournamentsComponent } from "./frontend/academies-profile/our-tournaments/our-tournaments.component";
import { ComingSoonComponent } from "./components/pages/coming-soon/coming-soon.component";
import { RefundPolicyComponent } from "./frontend/refund-policy/refund-policy.component";
import { AcademyPaymentPageComponent } from "./frontend/academy/payment/academy-payment-page.component";
import { TournamentComponent } from "./frontend/tournament/tournament.component";
import { RaceToGoldComponent } from "./frontend/tournament/race-to-gold/race-to-gold.component";
import { TournamentFactsheetComponent } from "./frontend/tournament/tournament-factsheet/tournament-factsheet.component";
import { TournamentDrawComponent } from "./frontend/tournament/tournament-draw/tournament-draw.component";
import { TournamentResultComponent } from "./frontend/tournament/tournament-result/tournament-result.component";
import { CreateTournamentsComponent } from "./frontend/academies-profile/our-tournaments/create-tournaments/create-tournaments.component";
import { CreatetournamentDetailsComponent } from "./frontend/academies-profile/our-tournaments/createtournament-details/createtournament-details.component";
import { PlayerListComponent } from "./frontend/academies-profile/our-tournaments/player-list/player-list.component";
import { SignUpComponent } from "./frontend/sign-up/sign-up.component";
import { AddresslogComponent } from "./manage/user/addresslog/addresslog.component";
import { PlayerTournamentComponent } from "./manage/user/player-tournament/player-tournament.component";
import { PlayerCertificateComponent } from "./manage/user/player-certificate/player-certificate.component";
import { TournamentDrawsComponent } from "./frontend/academies-profile/our-tournaments/draws/draws.component";
import { TournamentListComponent } from "./manage/tournamentlist/tournamentlist.component";
import { AccountComponent } from "./manage/account/account.component";
import { TdsDataComponent } from "./manage/account/tds-data/tds-data.component";
import { SkilledOpponentComponent } from "./manage/user/skilled-opponent/skilled-opponent.component";
import { RankingListComponent } from "./manage/user/ranking-list/ranking-list.component";
import { AcademyTournamentIncomeListComponent } from "./manage/academies/income/income.component";
import { KycComponent } from "./manage/user/kyc/kyc.component";
import { KycFormComponent } from "./frontend/profile/info/kycForm/kycForm.component";
import { LeaderboardComponent } from "./frontend/leaderboard/leaderboard.component";
import { WalletRedemptionRequest } from "./manage/walletRedemptionRequest/walletRedemptionRequest.componenet";
import { WalletRedemptionComponent } from "./frontend/wallet/wallet-redemption/wallet-redemption.component";
import { PlayerDetailsComponent } from "./frontend/leaderboard/player-details/player-details.component";
import { AddKycComponent } from './manage/user/kyc/add-kyc/add-kyc.component';
import { MatchesInfoComponent } from './manage/user/matches-info/matches-info.component';
import { RankingHistoryComponent } from './manage/user/ranking-history/ranking-history.component';
import { SkillHistoryComponent } from './manage/user/skill-history/skill-history.component';
import { UserDeleteRequestListComponent } from "./manage/user/userDeleteRequest/userDeleteRequest.component";
import { AcademyWalletRedeemComponent } from "./frontend/academy/academy-wallet/academy-wallet-redeemption/academy-wallet-redeem";
import { AcademyWalletRedemptionRequest } from "./manage/academyWalletRedemptionList/academyWalletRedemptionList.component";
import { CheckmobileComponent } from "./frontend/checkMobile/checkMobile.component";
import { ReferAndEarnComponent } from './frontend/refer-and-earn/refer-and-earn.component';
import { UserReferAndEarnComponent } from './frontend/user-refer-and-earn/refer-and-earn.component';
import { AcademyReferrerListComponent } from "./frontend/academy/academyReferrerList/academyReferrerList.component";
import { UserKycListComponent } from "./frontend/profile/info/userKycList/user-kyc-list.component";
import { UservideoComponent } from "./manage/user/userlist/user.component";
import { AddUserwalletComponent } from "./manage/user/wallethistory/add/add.component";
import { ContestLeaderboardDetailsComponent } from './frontend/contest-leader-board/contest-leaderboard-details/contest-leaderboard-details.component';
import { AdminUserKycListComponent } from "./manage/kycList/userKycList/userKycList.component";
import { AcademyKycListComponent } from "./manage/kycList/academyKycList/academyUserKycList.component";
import { PlayerAchievementsComponent } from './frontend/profile/player-achievements/player-achievements.component';
import { PlayerTicketComponent } from './frontend/profile/player-ticket/player-ticket.component';
import { NewsDetailsComponent } from './frontend/news-details/news-details.component';
//import { AcademytournamentComponent } from './manage/academytournament/academytournament.component';
import { SignInSignUpComponent } from "./frontend/sign-in-sign-up/sign-in-sign-up.component";
import { SignInSignUpComponent2 } from "./frontend/sign-in-sign-up2/sign-in-sign-up.component";
import { MyAchivementsComponent } from "./frontend/profile/my-achivements/my-achivements.component";
import { ContestLeaderboardComponent } from "./frontend/contest/leaderboard/leaderboard.component";
import { ContestPlayerDetailsComponent } from "./frontend/contest/leaderboard/player-details/player-details.component";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { AcademiesReviewsComponent } from './frontend/academies-profile/academies-reviews/academies-reviews.component';

// import { UserKycComponent } from "./frontend/profile/info/kyc/kyc.component";
import { UserAadharKycComponent } from "./frontend/profile/info/kyc/kyc.component";
import { UserBankDetailsComponent } from "./frontend/profile/info/kyc/bank-details/bank-details.component";
import { AdminUserBankDetailsComponent } from "./manage/user/kyc/bank-details/bank-details.component";
import { ViewKycDetailsComponent } from './frontend/profile/info/kyc/view-kyc-details/view-kyc-details.component';
import { ContestMatchStatsComponent } from "./frontend/contest/contest-match-stats/contest-match-stats.component";
import { UserinvoicesComponent } from "./manage/userinvoices/userinvoices.component";
import { AcademyTournamentReport } from "./manage/academytournamentreport/academyTournamentReport.componenet";
import { UserCommissionComponent } from "./manage/usercommission/usercommission.component";
import { UserPaymentDetailsComponent } from "./manage/userpaymentdetails/userpaymentdetails.component";
import { AcademyPaymentDetailsComponent } from "./manage/academypaymentdetails/academypaymentdetails.component";
import { DobVerification } from "./frontend/profile/info/dob-verification/dob-verification.component";
import { HomepageVideoComponent } from './manage/homepage-video/homepage-video.component';
import { HomePageVideoAddComponent } from './manage/homepage-video/add/add.component';
import { HomePageVideoEditComponent } from './manage/homepage-video/edit/edit.component';
import { SubtractUserwalletComponent } from "./manage/user/wallethistory/subtract/subtract.component";
import { AddMyCoachComponent } from "./manage/user/coaches/add-coach/add-coach.component";
import { myCoachesComponent } from "./manage/user/coaches/coaches.component";
import { UserContestLeaderboardComponent } from './frontend/contest-leader-board/user-contest-leaderboard/user-contest-leaderboard.component';
import { PageScreenshotDirective } from './Directives/page-screenshot.directive';
import { ProfileRankingComponent } from './frontend/profile/profile-ranking/profile-ranking.component';
import { ContestPaymentSelectionPageComponent } from './frontend/contest/contest-payment-selection-page/contest-payment-selection-page.component';
import { WalletConversionComponent } from './frontend/wallet/wallet-conversion/wallet-conversion.component';
import { NumberFormatterPipe } from './Pipes/number-formatter.pipe';
import { TdsInfoPageComponent } from './frontend/tds-info-page/tds-info-page.component';
import { TdsReportComponent } from './manage/tds-report/tds-report.component';
import { AcademymembershipComponent } from './manage/academymembership/academymembership.component';
import { AddAcademymembershipComponent } from './manage/academymembership/add-academymembership/add-academymembership.component';
import { EditAcademymembershipComponent } from './manage/academymembership/edit-academymembership/edit-academymembership.component';
import { FeaturedThisWeekComponent } from './manage/featured-this-week/featured-this-week.component';
import { AddComponent } from './manage/featured-this-week/add/add.component';
import { EditComponent } from './manage/featured-this-week/edit/edit.component';
import { CreditNoteComponent } from './manage/credit-note/credit-note.component';
import { PushNotificationsComponent } from './manage/push-notifications/push-notifications.component';
import { AddPushNotificationComponent } from "./manage/push-notifications/add/add.component";
import { EditPushNotificationComponent } from "./manage/push-notifications/edit/edit.component";
import { EditChargesComponent } from "./manage/charges/edit/edit.component";

import { SponsorsComponent } from './manage/sponsors/sponsors.component';
import { AddSponsorsComponent } from './manage/sponsors/add/add.component';
import { EditSponsorsComponent } from './manage/sponsors/edit/edit.component';
import { AcademyDemoRequestComponent } from './manage/academy-demo-request/academy-demo-request.component';
import { TournamentReportComponent } from './manage/tournament-report/tournament-report.component';
import { AccountsReportComponent } from './manage/user/accounts-report/accounts-report.component';

import { RewardListComponent } from './manage/rewards/list/list.component';
import { RewardAddComponent } from './manage/rewards/add/add.component';
import { RewardEditComponent } from './manage/rewards/edit/edit.component';
import { RewardRequestListComponent } from './manage/rewards/request-list/request-list.component';

// import { HighlightComponent } from './manage/highlights/highlight.component';
// import { AddHighlightsComponent } from './manage/highlights/add-highlights/add-highlights.component';
// import { EditHighlightsComponent } from './manage/highlights/edit-highlights/edit-highlights.component';

import { PlayerCourtsComponent } from './manage/user/player-courts/player-courts.component';
import { UserReportComponent } from './manage/user-report/user-report.component';
import { ActiveUserReportComponent } from './manage/active-user-report/active-user-report.component';
import { UserJourneyComponent } from './manage/user-journey/user-journey.component';
import { RevenueComponent } from './manage/revenue/revenue.component';
import { AcademyAffiliationRevenueComponent } from './manage/academy-affiliation-revenue/academy-affiliation-revenue.component';
import { TournamentRevenueComponent } from './manage/tournament-revenue/tournament-revenue.component';
import { CourtBookingsRevenueComponent } from './manage/court-bookings-revenue/court-bookings-revenue.component';
import { AcademyEnrolmentRevenueComponent } from './manage/academy-enrolment-revenue/academy-enrolment-revenue.component';
import { FindAPartnerRevenueComponent } from './manage/find-a-partner-revenue/find-a-partner-revenue.component';
import { AttendanceComponent } from './manage/attendance/attendance.component';
import { PerformanceAnalyticsComponent } from './manage/performance-analytics/performance-analytics.component';
import { UserSubscriptionComponent } from "./manage/user-subscription/user-subscription.component";
import { UserSubscriptionHistoryComponent } from "./manage/user/user-subscription/user-subscription.component";
import { PickleballTournamentlistComponent } from './manage/pickleball-tournamentlist/pickleball-tournamentlist.component';
import { PadelTournamentlistComponent } from './manage/padel-tournamentlist/padel-tournamentlist.component';
import { UserBatchEnrolmentComponent } from './manage/user/user-batch-enrolment/user-batch-enrolment.component';
import { SendNotificationsComponent } from './manage/send-notifications/send-notifications.component';
import { AddSendNotificationComponent } from "./manage/send-notifications/add/add.component";
import { PickleballTournamentFactsheetComponent } from './frontend/pickleball-tournament/pickleball-tournament-factsheet/pickleball-tournament-factsheet.component';
import { PadelTournamentFactsheetComponent } from './frontend/padel-tournament/padel-tournament-factsheet/padel-tournament-factsheet.component';
// import { ScholarshipComponent } from './manage/race-to-gold/scholarship/scholarship.component';
// import { RewindComponent } from './manage/race-to-gold/rewind/rewind.component';
// import { WinnersTestimonialsComponent } from './manage/race-to-gold/winners-testimonials/winners-testimonials.component';
// import { ParentsTestimonialsComponent } from './manage/race-to-gold/parents-testimonials/parents-testimonials.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { OrdinalDatePipe } from './Pipes/ordinal-date.pipe';
import { UserWalletReportComponent } from './manage/user-wallet-report/user-wallet-report.component';
import { AccountDeletionComponent } from './frontend/account-deletion/account-deletion.component';
FullCalendarModule.registerPlugins([
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin,
]);
export const routes: Routes = [];

// SwiperOptions from 'swiper' could also be used here instead of SwiperConfigInterface
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: "horizontal",
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  //centeredSlides: true,
  loop: true,
  effect: "coverflow",
  scrollbar: false,
};

@NgModule({
  imports: [
    ImageCropperModule,
    BrowserModule,
    AngMusicPlayerModule,
    SwiperModule,
    EditorModule,
    // VimeModule,
    //NgxAudioPlayerModule,

    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AccordionModule,
    AutoCompleteModule,
    AvatarModule,
    AvatarGroupModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CustomFormsModule,
    CalendarModule,
    CardModule,
    CarouselModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ChipModule,
    CodeHighlighterModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ColorPickerModule,
    ContextMenuModule,
    DataViewModule,
    DialogModule,
    DividerModule,
    DropdownModule,
    DragDropModule,
    FieldsetModule,
    FileUploadModule,
    FullCalendarModule,
    GalleriaModule,
    InplaceModule,
    InputNumberModule,
    InputMaskModule,
    InputSwitchModule,
    InputTextModule,
    InputTextareaModule,
    KnobModule,
    LightboxModule,
    ImageModule,
    ListboxModule,
    MegaMenuModule,
    MenuModule,
    MenubarModule,
    MessageModule,
    MessagesModule,
    MultiSelectModule,
    OrderListModule,
    OrganizationChartModule,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PanelMenuModule,
    PasswordModule,
    PickListModule,
    ProgressBarModule,
    RadioButtonModule,
    RatingModule,
    RippleModule,
    ScrollPanelModule,
    ScrollTopModule,
    SelectButtonModule,
    SkeletonModule,
    SidebarModule,
    SlideMenuModule,
    SliderModule,
    SplitButtonModule,
    SplitterModule,
    StepsModule,
    TableModule,
    TabMenuModule,
    TabViewModule,
    TagModule,
    TerminalModule,
    TieredMenuModule,
    TimelineModule,
    ToastModule,
    ToggleButtonModule,
    ToolbarModule,
    TooltipModule,
    TreeModule,
    TreeSelectModule,
    TreeTableModule,
    VirtualScrollerModule,
    AppCodeModule,
    VimeModule,
    NgOtpInputModule,
    SwiperModule,
    LazyLoadImageModule,
    RouterModule.forRoot(routes, {
      anchorScrolling: "enabled",
    }),
  ],
  declarations: [
    AboutUsComponent,
    AppComponent,
    AppMainComponent,
    AppRightpanelComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppConfigComponent,
    AppTopBarComponent,
    AppFooterComponent,
    TplForPlayersComponent,
    TplForClubsComponent,
    DashboardDemoComponent,
    FormLayoutDemoComponent,
    FloatLabelDemoComponent,
    FaqComponent,
    InvalidStateDemoComponent,
    InputDemoComponent,
    ButtonDemoComponent,
    SignInComponent,
    ContactUsComponent,
    TableDemoComponent,
    ListDemoComponent,
    TreeDemoComponent,
    PanelsDemoComponent,
    OverlaysDemoComponent,
    MediaDemoComponent,
    MenusDemoComponent,
    MessagesDemoComponent,
    MessagesDemoComponent,
    MiscDemoComponent,
    ChartsDemoComponent,
    EmptyDemoComponent,
    FileDemoComponent,
    DocumentationComponent,
    DisplayComponent,
    ElevationComponent,
    FlexboxComponent,
    GridComponent,
    IconsComponent,
    WidgetsComponent,
    SpacingComponent,
    TypographyComponent,
    TextComponent,
    AppCrudComponent,
    AppCalendarComponent,
    AppLoginComponent,
    AppInvoiceComponent,
    AppHelpComponent,
    AppNotfoundComponent,
    AppErrorComponent,
    AppTimelineDemoComponent,
    AppAccessdeniedComponent,
    BannerComponent,
    BannerAddComponent,
    BannerEditComponent,
    HomeComponent,
    FrontendComponent,
    HeaderComponent,
    CategoryComponent,
    AgentsComponent,
    FooterComponent,
    LoaderComponent,
    ManageComponent,
    AdminLoginComponent,
    AdminComponent,
    AdminAddComponent,
    AdminEditComponent,
    AdminViewComponent,
    DataProtectionPolicyComponent,
    EmptyComponent,
    PricingComponent,
    RoleComponent,
    WalletComponent,
    RoleAddComponent,
    RoleEditComponent,
    RoleViewComponent,
    CategoryAddComponent,
    CategoryEditComponent,
    CategoryViewComponent,
    SubcategoryComponent,
    SubcategoryAddComponent,
    SubcategoryEditComponent,
    SubcategoryViewComponent,
    UserComponent,
    PrivacypolicyComponent,
    TermsnconditionComponent,
    UserAddComponent,
    UserEditComponent,
    UserViewComponent,
    MyAccountComponent,
    UserMyAccountEditComponent,
    OrdersComponent,
    ViewCustomerVenueOrderComponent,
    CookiePolicyComponent,
    ChangeLogComponent,
    ClubComponent,
    ClubAddComponent,
    ClubEditComponent,
    ClubLeaguesComponent,
    ResetPasswordComponent,
    productComponent,
    FindPartnerComponent,
    whatistplComponent,
    QuizComponent,
    WallethistoryComponent,
    ContestComponent,
    ContestDetailsComponent,
    ContestHistoryComponent,
    MyContestComponent,
    InformationComponent,
    SkillsComponent,
    RankingComponent,
    MatchesComponent,
    OpponentsComponent,
    BlogComponent,
    BlogviewComponent,
    ContestLeaderBoardComponent,
    MyScheduleComponent,
    UserscheduleListComponent,
    FindPartnerChatHistoryComponent,
    UserDeleteRequestListComponent,
    ProfilerequestComponent,
    SafepipePipe,
    AbouttheleagueComponent,
    ScoretableComponent,
    TeamsComponent,
    SponsersComponent,
    MediaComponent,
    HighlightsComponent,
    AcademiesProfileComponent,
    AcademiesProfileEditComponent,
    AcademiesProfileSliderComponent,
    TopPlayersComponent,
    CourtTypesComponent,
    BranchesComponent,
    CoachesComponent,
    AcademyHighlightsComponent,
    TeamDetailsComponent,
    MyTournamentComponent,
    ProfileHeaderComponent,
    ProfileEditComponent,
    ProfileEdit2Component,
    AcademiesHeaderComponent,
    AcademyThankyouPageComponent,
    AcademyFrontendPaymentListComponent,
    AcademyTournamentIncomeListComponent,
    OurTournamentsComponent,
    ComingSoonComponent,
    RefundPolicyComponent,
    AcademyPaymentPageComponent,
    TournamentComponent,
    RaceToGoldComponent,
    TournamentFactsheetComponent,
    TournamentDrawComponent,
    TournamentResultComponent,
    CreateTournamentsComponent,
    CreatetournamentDetailsComponent,
    PlayerListComponent,
    //AcademytournamentComponent,
    PlayerListComponent,
    SignUpComponent,
    AddresslogComponent,
    PlayerTournamentComponent,
    PlayerCertificateComponent,
    TournamentDrawsComponent,
    TournamentListComponent,
    AccountComponent,
    TdsDataComponent,
    SkilledOpponentComponent,
    RankingListComponent,
    KycComponent,
    KycFormComponent,
    LeaderboardComponent,
    WalletRedemptionRequest,
    WalletRedemptionComponent,
    PlayerDetailsComponent,
    AddKycComponent,
    MatchesInfoComponent,
    RankingHistoryComponent,
    SkillHistoryComponent,
    AcademyWalletComponent,
    AcademyWalletRedeemComponent,
    AcademyWalletRedemptionRequest,
    CheckmobileComponent,
    ReferAndEarnComponent,
    UserReferAndEarnComponent,
    UserKycListComponent,
    AcademyReferrerListComponent,
    UservideoComponent,
    AddUserwalletComponent,
    ContestLeaderboardDetailsComponent,
    AdminUserKycListComponent,
    AcademyKycListComponent,
    PlayerAchievementsComponent,
    PlayerTicketComponent,
    NewsDetailsComponent,
    SignInSignUpComponent,
    SignInSignUpComponent2,
    MyAchivementsComponent,
    ContestLeaderboardComponent,
    ContestPlayerDetailsComponent,
    AcademiesReviewsComponent,
    //UserKycComponent,
    UserAadharKycComponent,
    DobVerification,
    UserBankDetailsComponent,
    AdminUserBankDetailsComponent,
    ViewKycDetailsComponent,
    ContestMatchStatsComponent,
    UserinvoicesComponent,
    UserCommissionComponent,
    AcademyTournamentReport,
    UserPaymentDetailsComponent,
    AcademyPaymentDetailsComponent,
    HomepageVideoComponent,
    HomePageVideoAddComponent,
    HomePageVideoEditComponent,
    SubtractUserwalletComponent,
    AddMyCoachComponent,
    myCoachesComponent,
    UserContestLeaderboardComponent,
    PageScreenshotDirective,
    ProfileRankingComponent,
    ContestPaymentSelectionPageComponent,
    WalletConversionComponent,
    NumberFormatterPipe,
    TdsInfoPageComponent,
    TdsReportComponent,
    AcademymembershipComponent,
    AddAcademymembershipComponent,
    EditAcademymembershipComponent,
    FeaturedThisWeekComponent,
    AddComponent,
    EditComponent,
    CreditNoteComponent,
    PushNotificationsComponent,
    AddPushNotificationComponent,
    EditPushNotificationComponent,
    EditChargesComponent,

    SponsorsComponent,
    AddSponsorsComponent,
    EditSponsorsComponent,

    AcademyDemoRequestComponent,
    TournamentReportComponent,
    AccountsReportComponent,

    RewardListComponent,
    RewardAddComponent,
    RewardEditComponent,
    RewardRequestListComponent,

    // HighlightComponent,
    // AddHighlightsComponent,
    // EditHighlightsComponent,


    PlayerCourtsComponent, UserReportComponent, ActiveUserReportComponent, UserJourneyComponent, RevenueComponent, AcademyAffiliationRevenueComponent, TournamentRevenueComponent, CourtBookingsRevenueComponent, AcademyEnrolmentRevenueComponent, FindAPartnerRevenueComponent, UserSubscriptionComponent, AttendanceComponent, PerformanceAnalyticsComponent,
    SendNotificationsComponent,
    AddSendNotificationComponent,
    PlayerCourtsComponent,
    UserSubscriptionHistoryComponent,
    PickleballTournamentlistComponent,
    PadelTournamentlistComponent,
    UserBatchEnrolmentComponent,
    PickleballTournamentFactsheetComponent,
    PadelTournamentFactsheetComponent,
    OrdinalDatePipe,
    UserWalletReportComponent,
    AccountDeletionComponent
    // ScholarshipComponent,
    // RewindComponent,
    // WinnersTestimonialsComponent,
    // ParentsTestimonialsComponent
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    CountryService,
    CustomerService,
    EventService,
    IconService,
    NodeService,
    PhotoService,
    ProductService,
    MenuService,
    AppMainComponent,
    AppComponent,
    LoaderService,
    // REQUIRED IF YOU USE JWT AUTHENTICATION
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
